<template>
  <div class="ab-upload-panel" :class="{'removeNone':disabled}">
	<template v-if="uploadProps.isImgUpload">
	<div class="images-upload-list"  :style="uploadProps.previewImgStyle" v-for="item in uploadList" :key="item.response?item.response.data:item.name + Math.random()">
		<template v-if="item.status === 'finished'">
			<img :src="`${previewBaseUrl}${item.response.data}&isThumbnail=${uploadProps.isMakeThumbnail?'1':'0'}`">
			<div class="images-upload-list-cover">
				<Icon type="ios-eye-outline" @click.native="previewImg(item)"></Icon>
				<Icon v-if="abPermission=='b'||abPermission=='w'" type="ios-trash-outline" @click.native="removeImg(item)"></Icon>
			</div>
		</template>
		<template v-else>
			<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
		</template>
	</div>
	</template>
    <Upload
      ref="upload"
      multiple
      :action="action"
	    :disabled="disabled"
      :with-credentials="true"
      :on-success="success"
      :on-remove="remove"
      :on-preview="preview"
      :show-upload-list="!uploadProps.isImgUpload"
      :accept="accept"
      :format="format"
      :on-format-error="formatError"
      :on-error="error"
      :before-upload="beforeUpload"
      :data="uploadData"
      :type="upType?upType:uploadProps.isImgUpload?'drag':'select'"
      :style="uploadProps.isImgUpload?'display: inline-block;':''"
    >
	<template v-if="uploadProps.isImgUpload">
		<div v-if="abPermission=='b'||abPermission=='w'" :style="uploadProps.previewImgStyle">
			<Icon type="ios-camera" size="20"></Icon>
		</div>
	</template>
	<template v-else>

      <div v-if="isCustomUpIcon">
          <slot v-if="abPermission=='b'||abPermission=='w'" name="upload-icon"></slot>
      </div>

      <div v-else>
        <Button
          v-if="abPermission=='b'||abPermission=='w'"
          :style="style"
          type="primary"
          shape="circle"
          icon="ios-cloud-upload-outline"
        >
          <slot></slot>
        </Button>
      </div>

    </template>
    </Upload>
	<div>

		<preview-image v-model="isPreview" :src="fileViewId?previewBaseUrl + fileViewId:''" z-index="9000"></preview-image>

	</div>
  </div>
</template>

<script>
import Vue from "vue";
import Setting from "@/setting";
import PreviewImage from "@/components/preview-image";
/**
 * <ab-upload v-model="data.kjcs.fjsc">​</ab-upload>
 */
export default {
  props: ["value", "abPermission", "accept", "format", "disabled",'imgParam','isImg','upType','isCustomUpIcon'],
  components: { PreviewImage },
  data: function() {
    return {
      action: "",
      style: "",
      uploadList: [],
      Refresh: false,
      
      uploadData : {},
		isPreview : false, //预览标识符
		previewBaseUrl : Setting.apiBaseURL + "sys/sysFile/download?fileId=", //预览地址
		fileViewId : '', //附件预览id
		modalParam :{
			title: "文件预览"
		},
		uploadProps : {
			isImgUpload : this.isImg | false, //是否图片上传
			isMakeThumbnail : true, //是否制作缩略图
			previewImgStyle : { //预览样式，宽高设置
				width : "80px",
				height : "80px",
				lineHeight : "80px"
			}
		}
    };
  },
  mounted: function() {
    this.disabled = true;
    this.action = Setting.apiBaseURL + "sys/sysFile/upload";
    this.uploadList = this.$refs.upload.fileList;

	//上传图片参数
	if(this.imgParam){
		try{
			Object.assign(this.uploadProps,this.imgParam);
		}catch(e){
			console.log(e);
		}
	}
	// 图片时，只能上传图片类型
	if (this.uploadProps.isImgUpload) {
		this.format = ['jpg', 'png', 'gif', 'bpm']
	}
	
    if (this.value && this.abPermission != "n") {
      //初始化数据
      JSON.parse(this.value).forEach(json => {
        this.uploadList.push({
          name: json.name,
          status: "finished",
          response: {
            data: json.id
          }
        });
      });
    }

    this.handleStyle();
  },
  methods: {
	beforeUpload : function(file){
		//附件上传前相关处理
		if(this.uploadProps && this.uploadProps.isMakeThumbnail && this.uploadProps.isImgUpload){
			this.uploadData.isMakeThumbnail = 1;
		}
        return true;
	},
    success: function(response, file, fileList) {
      this.Refresh = true;
      if (response && !response.isOk) {
        this.abTools.ArrayUtil.remove(file, fileList);
        this.$Message.error(response.msg);
        return;
      }
      let list = [];
      fileList.forEach(item => {
        let json = {
          name: item.name,
          id: item.response.data
        };
        list.push(JSON.stringify(json));
      });
      this.$emit("input", "[" + list.join(",") + "]");
    },
    remove: function(file, fileList) {
      this.success(null, file, fileList);
    },
    preview: function(file) {
      let url =
        Setting.apiBaseURL +
        "sys/sysFile/download?fileId=" +
        file.response.data;
      window.open(url, "_blank");
    },
    removeImg : function(file){

		const fileList = this.$refs.upload.fileList;
	 	this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
	  
		this.success(null,file,fileList);
	},
	previewImg:function(file){ //图片预览
		this.fileViewId = file.response.data;
		this.isPreview = true;
		this.modalParam.title = file.name;
	}, 
    handleStyle: function() {
      if (!this.$vnode.context.$validity) {
        this.$vnode.context.$validity = {};
      }
      if (this.abPermission == "b") {
        if (!this.value || this.value == "[]") {
          this.$vnode.context.$validity[this.$attrs.desc] = "必填";
          this.style = "border: 1px solid #ed4014;";
        } else {
          delete this.$vnode.context.$validity[this.$attrs.desc];
          this.style = "";
        }
      } // 动态权限后切换权限
      else if (this.$vnode.context.$validity[this.$attrs.desc]) {
        delete this.$vnode.context.$validity[this.$attrs.desc];
        this.style = "";
      }
    },
    formatError(file, fileList) {
      this.$Message.error("仅支持文件类型：" + this.format.join(","));
    },
    error(error, file, fileList) {
      this.$Message.error(
        $t('page.common.uploadError')
      );
    }
  },
  watch: {
    value: function(oldValue, newValue) {
      if (this.value && this.abPermission != "n" && !this.Refresh) {
        JSON.parse(this.value).forEach(json => {
          this.uploadList.push({
            name: json.name,
            status: "finished",
            response: {
              data: json.id
            }
          });
        });
      }
      this.handleStyle();
    },
    abPermission: function() {
      this.handleStyle();
    }
  }
};
</script>
<style lang="less" scoped>
.removeNone::v-deep .ivu-upload-list-file .ivu-upload-list-remove {
  display: none !important;
}
.removeNone::v-deep .ivu-upload-select {
  display: none !important;
}


	.ab-upload-panel{
		
		.images-upload-list{
			display: inline-block;
			text-align: center;
			border: 1px solid transparent;
			border-radius: 4px;
			overflow: hidden;
			background: #fff;
			position: relative;
			box-shadow: 0 1px 1px rgba(0,0,0,.2);
			margin-right: 4px;

			img{
				width: 100%;
				height: 100%;
			}

			.images-upload-list-cover{
				display: none;
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				background: rgba(0,0,0,.6);

				i{
					color: #fff;
					font-size: 20px;
					cursor: pointer;
					margin: 0 2px;
				}
				
			}

		}

		.images-upload-list:hover .images-upload-list-cover{
			display: block;
		}
		
	}
</style>
